"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = void 0;
/**
 * Get nested object path
 * This is a quick alternative to Lodash.get
 * @param value Object-like reference
 * @param path Expected property path to the target value
 * @param defaultValue Fallback value, defaults to undefined
 * @returns
 */
var get = function (value, path, defaultValue) {
    if (defaultValue === void 0) { defaultValue = undefined; }
    return String(path)
        .split('.')
        .reduce(function (acc, v) {
        try {
            acc = (acc === null || acc === void 0 ? void 0 : acc[v]) || defaultValue;
        }
        catch (e) {
            return defaultValue;
        }
        return acc;
    }, value);
};
exports.get = get;
